import { Stack, Textarea, TextInput } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

interface BaseMessageFormValues {
  title: string;
  message: string;
}

interface SendMessageFormProps<T extends BaseMessageFormValues> {
  children: ReactNode;
  form: UseFormReturnType<T>;
}

const SendMessageForm = <T extends BaseMessageFormValues>({
  children,
  form,
}: SendMessageFormProps<T>) => {
  const { t } = useTranslation("message");

  return (
    <>
      <Stack gap={"sm"}>
        <TextInput
          {...form.getInputProps("title")}
          required
          label={t("title")}
          placeholder={t("title")}
        />
        <Textarea
          {...form.getInputProps("message")}
          required
          label={t("message")}
          placeholder={t("message")}
          rows={5}
        />
      </Stack>

      {children}
    </>
  );
};

export default SendMessageForm;
